<template>
  <el-dialog
    title="作品签章"
    width="520px"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    @closed="handleClosed"
  >
    <div class="work-seal-dialog">
      <div class="work-info">
        <div class="work-info-row">
          <span class="work-info-label">作品名称</span>
          <span class="work-info-value">{{ workInfo.workName || '--' }}</span>
        </div>
        <div class="work-info-row">
          <span class="work-info-label">流水号</span>
          <span class="work-info-value">{{ workInfo.dciWorkId || '--' }}</span>
        </div>
        <div class="work-info-row">
          <span class="work-info-label">著作权人</span>
          <span class="work-info-value">{{ workInfo.copyrightOwnerName || '--' }}</span>
        </div>
      </div>

      <div class="signer-tip">
        <i class="el-icon-info"></i>
        <span>
          使用{{ workInfo.signerType === 'AGENT' ? '经办人' : '著作权人' }}
          <strong>{{ workInfo.signerName || '--' }}</strong>
          的个人支付宝扫一扫立即签署
        </span>
      </div>

      <div class="qr-code-wrap">
        <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="签署链接二维码" />
        <div v-else class="qr-code-loading">二维码生成中...</div>
      </div>
      <div class="qr-code-caption">请使用支付宝扫描二维码</div>

      <div class="seal-link-row">
        <span class="seal-link-label">签署链接：</span>
        <a :href="sealUrl" target="_blank" rel="noopener noreferrer">{{ sealUrl }}</a>
        <el-button type="text" @click="copySealUrl">复制链接</el-button>
      </div>

      <div class="seal-actions">
        <a
          class="el-button el-button--primary open-sign-link"
          :href="sealUrl"
          target="_blank"
          rel="noopener noreferrer"
        >打开链接进行签署</a>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'WorkSealDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    workInfo: {
      type: Object,
      default: () => ({})
    },
    sealUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      qrCodeDataUrl: ''
    }
  },
  watch: {
    visible (value) {
      if (value) {
        this.generateQrCode()
      } else {
        this.qrCodeDataUrl = ''
      }
    },
    sealUrl () {
      if (this.visible) {
        this.generateQrCode()
      }
    }
  },
  methods: {
    async generateQrCode () {
      const sealUrl = this.sealUrl
      this.qrCodeDataUrl = ''
      if (!sealUrl) return

      try {
        const qrCodeDataUrl = await QRCode.toDataURL(sealUrl, {
          width: 220,
          margin: 1,
          errorCorrectionLevel: 'M'
        })
        if (this.visible && this.sealUrl === sealUrl) {
          this.qrCodeDataUrl = qrCodeDataUrl
        }
      } catch (error) {
        this.$message.error('二维码生成失败')
      }
    },
    async copySealUrl () {
      if (!this.sealUrl) return

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.sealUrl)
        } else {
          this.copyWithTextarea(this.sealUrl)
        }
        this.$message.success('链接已复制')
      } catch (error) {
        try {
          this.copyWithTextarea(this.sealUrl)
          this.$message.success('链接已复制')
        } catch (copyError) {
          this.$message.error('复制失败，请手动复制链接')
        }
      }
    },
    copyWithTextarea (value) {
      const textarea = document.createElement('textarea')
      textarea.value = value
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      textarea.setSelectionRange(0, value.length)
      const copied = document.execCommand('copy')
      document.body.removeChild(textarea)
      if (!copied) {
        throw new Error('copy failed')
      }
    },
    handleClose () {
      this.$emit('update:visible', false)
    },
    handleClosed () {
      this.qrCodeDataUrl = ''
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss" scoped>
.work-seal-dialog {
  color: #303133;
  padding: 0 4px 4px;
}

.work-info {
  padding: 14px 16px;
  background-color: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.work-info-row {
  display: flex;
  line-height: 24px;

  & + & {
    margin-top: 8px;
  }
}

.work-info-label {
  flex: none;
  width: 76px;
  color: #909399;
}

.work-info-value {
  flex: 1;
  min-width: 0;
  color: #303133;
  word-break: break-all;
}

.signer-tip {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 6px;
  margin-top: 16px;
  padding: 10px 12px;
  color: #409eff;
  line-height: 22px;
  text-align: left;
  background-color: #ecf5ff;
  border-radius: 6px;

  i {
    margin-top: 4px;
  }

  strong {
    margin: 0 2px;
    color: #303133;
  }
}

.qr-code-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 242px;
  height: 242px;
  margin: 20px auto 8px;
  padding: 10px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(48, 49, 51, 0.08);
  box-sizing: border-box;

  img {
    display: block;
    width: 220px;
    height: 220px;
  }
}

.qr-code-loading {
  color: #909399;
}

.qr-code-caption {
  margin-bottom: 18px;
  color: #909399;
  font-size: 13px;
  text-align: center;
}

.seal-link-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  background-color: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 6px;

  > a {
    flex: 1;
    min-width: 0;
    color: #606266;
    line-height: 20px;
    word-break: break-all;
  }

  .el-button {
    flex: none;
    padding: 0;
    line-height: 20px;
  }
}

.seal-link-label {
  flex: none;
}

.seal-actions {
  margin-top: 18px;
  text-align: center;
}

.open-sign-link {
  min-width: 150px;
  text-decoration: none;
}
</style>
